import _ from 'lodash';
import * as React from 'react';
import { ProviderBadge } from '../badge';
import * as S from './provider-search-result.styles';

export interface IProviderSearchResultProps {
    id?: string;
    first?: string;
    suffix?: string;
    last?: string;
    email?: string;
    npi?: string;
    type?: string;
    inactive?: boolean;
    selected?: boolean;
}

export const ProviderSearchResult: React.FC<IProviderSearchResultProps> = (props: IProviderSearchResultProps) => {
    const { id, first, suffix, last, email, npi, type, inactive, selected } = props;
    return (
        <S.Result selected={selected}>
            <S.Provider>
                <S.ProviderTop>
                    {inactive && <b>INACTIVE</b>}
                    <b>Provider</b>
                    <S.Spacer />
                    <b>Type</b>
                    <span>{_.startCase(_.toLower(type))}</span>
                    <b>NPI</b>
                    <span>{npi}</span>
                    <b>{email}</b>
                </S.ProviderTop>
                <S.ProviderBottom>
                    <S.ProviderName inactive={inactive}>
                        {first} {last}
                    </S.ProviderName>
                    <S.Spacer />
                    <ProviderBadge
                        id={id}
                        first={first}
                        suffix={suffix}
                        last={last}
                        tooltip="Find claims for this Provider"
                    />
                </S.ProviderBottom>
            </S.Provider>
        </S.Result>
    );
};
